<header><img class="lfm_main-logo" src="assets/images/lfmcorporatelogo_short.png"> {{ title }}</header>
<nav class="mdl-navigation">
  <base-menu-item *ngFor="let item of menu" [data]="item"></base-menu-item>

  <div class="mdl-layout-spacer"></div>
</nav>
